import React, { createContext, useContext, useMemo } from 'react'
import { useUser } from '@fs/zion-user'
import { usePermission } from '@fs/zion-permissions'
import { usePreference } from '@fs/zion-preferences'
import { useGetTempleEligible, useGetUserPoints } from '../hooks/api'

const UserDetailsContext = createContext()
export const useUserDetailsContext = () => useContext(UserDetailsContext)

export default function UserDetailsProvider({ children }) {
  const user = useUser()
  const [isMember] = usePermission('MemberContentPermission', 'DiscoveryUserContext')
  const showRomanPref = usePreference('tree.showNamesInRomanScript')

  const readyToLoadUserPoints = !!user?.signedIn
  const { query, data: userPointsData } = useGetUserPoints(readyToLoadUserPoints)

  const readyToGetTempleEligible = user?.signedIn && isMember
  const { data: templeEligibleData } = useGetTempleEligible(readyToGetTempleEligible)

  // Removed the reducer which was overkill
  const contextValue = useMemo(
    () => ({
      points: userPointsData?.total ?? null,
      templeEligibleDate: templeEligibleData?.eligibleDate ?? null,
      showRoman: user?.signedIn && typeof showRomanPref === 'boolean' ? showRomanPref : false,
      loadUserPoints: query?.refetch,
    }),
    [userPointsData?.total, templeEligibleData?.eligibleDate, user?.signedIn, showRomanPref, query?.refetch]
  )

  return <UserDetailsContext.Provider value={contextValue}>{children}</UserDetailsContext.Provider>
}
